import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import styles from './TeamfulCollaborationSuccessMessage.less';
import { useTeamfulCollaborationSuccessMessageQuery } from '@trello/graphql/generated';
import {
  Button,
  ButtonSizes,
  ButtonTypes,
} from 'app/common/components/controls/button/button';
import { IconName } from 'app/common/components/controls/icon';
import { UpgradePromptFull } from 'app/src/components/UpgradePrompts/UpgradePromptFull';
import { Facepile } from 'app/src/components/Facepile';
import { Noun, Verb, trackUe } from '@trello/analytics';

const PartyPopper = require('resources/images/teamlesscolaboration/partypopper.svg');

const format = forNamespace('teamful collaboration prompt');

interface TeamfulCollaborationSuccessMessageProps {
  onClose: () => void;
  orgId: string;
}

export const TeamfulCollaborationSuccessMessage: React.FunctionComponent<TeamfulCollaborationSuccessMessageProps> = ({
  onClose,
  orgId,
}) => {
  // The Apollo cache may not have been fully updated after earlier mutations,
  // which necessitates the use of `network-only` to ensure query accuracy.
  const { data } = useTeamfulCollaborationSuccessMessageQuery({
    variables: { orgId },
    fetchPolicy: 'network-only',
  });
  const orgName = data?.organization?.name;
  const orgDisplayName = data?.organization?.displayName;
  const memberIds = data?.organization?.members?.map((member) => member.id);

  const upgradePromptCTATrackEvent = () => {
    trackUe({
      category: Noun.TEAM_PAGE,
      verb: Verb.OPENS,
      directObj: Noun.TEAM_PAGE_BC_TAB,
      method:
        'by clicking full upgrade prompt in the teamless collaboration prompt',
      context: {
        orgId,
      },
    });
  };

  return (
    <div className={styles.successMessage}>
      <div className={styles.successHeader}>
        <div className={styles.partyPopper}>
          <img alt="" className={styles.partyPopper} src={PartyPopper} />
        </div>
        <p className={styles.successMessageMuted}>
          {format(['success', 'title-2'])}
        </p>
        <p className={styles.successMessageLoud}>
          <span className={styles.orgDisplayName}>{orgDisplayName}</span>{' '}
          <span>{format(['success', 'description'])}</span>
        </p>
        <div className={styles.facepileWrapper}>
          <Facepile memberIds={(memberIds as string[]) || []} />
        </div>
      </div>
      <UpgradePromptFull
        content={format(['upgrade prompt', 'content-2'])}
        cta={format(['upgrade prompt', 'cta'])}
        ctaLink={`${orgName}/billing`}
        orgId={orgId}
        ctaOnClick={upgradePromptCTATrackEvent}
        headline={format(['upgrade prompt', 'headline'])}
        iconName={IconName.BusinessClass}
        source="teamfulCollaborationSuccessMessage"
      />
      <Button
        buttonType={ButtonTypes.PRIMARY}
        className={styles.successMessageButton}
        onClick={onClose}
        size={ButtonSizes.FULLWIDTH}
      >
        {format(['success', 'button'])}
      </Button>
    </div>
  );
};
